import { render, staticRenderFns } from "./ListHabitsTracker.vue?vue&type=template&id=1140d3dc"
import script from "./ListHabitsTracker.vue?vue&type=script&lang=js"
export * from "./ListHabitsTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports